import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  Box,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'

const fmt = n => Number(n||0).toFixed(2)

export default function SalarySmsSheet() {
  const [search] = useSearchParams()
  const staffId = search.get('staff_id')
  const year    = search.get('year')
  const month   = search.get('month')

  const [slip, setSlip]       = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError]     = useState('')

  useEffect(() => {
    if (!staffId || !year || !month) {
      setError('Missing query parameters.')
      setLoading(false)
      return
    }
    fetch(`https://htm.bayex.lk/api/salary_management.php?year=${year}&month=${month}`)
      .then(r => r.json())
      .then(data => {
        const found = Array.isArray(data)
          ? data.find(s => String(s.staff_id) === staffId)
          : null
        if (!found) {
          setError('No record found.')
        } else {
          setSlip(found)
        }
      })
      .catch(() => setError('Failed to load data.'))
      .finally(() => setLoading(false))
  }, [staffId, year, month])

  if (loading) {
    return (
      <Box textAlign="center" mt={4}>
        <CircularProgress />
      </Box>
    )
  }
  if (error) {
    return (
      <Box textAlign="center" mt={4}>
        <Typography color="error">{error}</Typography>
      </Box>
    )
  }

  return (
    <Box maxWidth="800px" mx="auto" p={2}>
      <Typography variant="h4" align="center" gutterBottom>
        Salary Sheet
      </Typography>
      <Typography variant="h6" align="center" gutterBottom>
        {slip.staff_name} — {month.padStart(2, '0')}/{year}
      </Typography>

      <Table sx={{ mb: 3 }}>
        <TableHead>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell align="right">Amount (Rs)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Days Present</TableCell>
            <TableCell align="right">{slip.days_present}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Basic Earned</TableCell>
            <TableCell align="right">{fmt(slip.basic_earning)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Extras</TableCell>
            <TableCell align="right">{fmt(slip.extra_earning)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ color: 'green' }}>Bonus</TableCell>
            <TableCell align="right" sx={{ color: 'green' }}>+{fmt(slip.bonus_total)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ color: 'red' }}>Penalties</TableCell>
            <TableCell align="right" sx={{ color: 'red' }}>−{fmt(slip.penalty_total)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Loan Deduction</TableCell>
            <TableCell align="right">−{fmt(slip.loan_deduction)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Advance Deduction</TableCell>
            <TableCell align="right">−{fmt(slip.advance_deduction)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Net Pay</strong></TableCell>
            <TableCell align="right"><strong>{fmt(slip.total_salary)}</strong></TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Typography variant="h6" gutterBottom>
        Daily Breakdown
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell align="right">Basic</TableCell>
            <TableCell align="right">Tips</TableCell>
            <TableCell align="right">Svc (50%)</TableCell>
            <TableCell align="right">Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {slip.daily_breakdown.map((d, idx) => (
            <TableRow key={idx}>
              <TableCell>{d.date}</TableCell>
              <TableCell align="right">{fmt(d.daily_basic)}</TableCell>
              <TableCell align="right">{fmt(d.daily_tip)}</TableCell>
              <TableCell align="right">{fmt(d.daily_svc)}</TableCell>
              <TableCell align="right">{fmt(d.daily_total)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* <Box textAlign="center" mt={3}>
        <Button variant="contained" onClick={() => window.print()}>
          Print
        </Button>
      </Box> */}
    </Box>
  )
}
